import Vue from 'vue'
import Storage from 'vue-ls';
import config from '../config/storage'

Vue.use(Storage, config);
